// @flow

import React, {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Section from './Section';
import {
  // Chip,
  Divider,
  FormControlLabel,
  Grid,
  makeStyles,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import {InfoOutlined} from '@material-ui/icons';

// import VisibilityIcon from '@material-ui/icons/Visibility';
// import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';
import {useIsFeatureInTier} from '../../../../../utils/component';
import {colors} from '../../../../../assets/styles/colors';

import AddToCartModal from '../Modals/CTAModals/AddToCartModal';
import WsspSaleModal from '../Modals/CTAModals/WsspSaleModal';
import OrderRequestModal from '../Modals/CTAModals/OrderRequestModal';
import BuyNowModal from '../Modals/CTAModals/BuyNowModal';

import {CTATypeObject} from '../../duck';
import type {ProductPageSetting, CTAType} from '../../duck';
import type {ProductPageSettingRequest} from '../../api';
import type {Theme} from '@material-ui/core';
import {useStoreMetadata} from '../../../../store/utils';
type Props = {
  disabled?: boolean,
  productPageSetting?: ProductPageSetting,
  saveProductPageSetting: ({
    productPageSettingRequest: ProductPageSettingRequest,
  }) => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  checkboxLabel: {
    fontWeight: 'normal',
    fontSize: '14px',
    color: colors.grey700,
  },
  label: {
    fontWeight: 'normal',
    fontSize: '14px',
    color: colors.grey900,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },

  divider: {
    backgroundColor: colors.grey300,
    margin: theme.spacing(2, 0),
  },
  button: {
    border: `1px solid ${colors.grey300}`,
    padding: theme.spacing(2, 0),
    borderRadius: 'none',
  },
  subtitle: {
    color: colors.grey900,
    fontSize: 14,
    fontWeight: 600,

    '& span': {
      fontWeight: 400,
      color: colors.grey600,
    },
  },
  row: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  newLabel: {
    background: '#F5F0FF',
    marginLeft: 10,
    fontWeight: 600,
    '& span': {
      fontSize: '11px!important',
      color: '#7B39FF',
    },
  },
  disabled: {
    color: colors.grey500,
  },
  recommended: {
    marginLeft: theme.spacing(1),
    background: '#EDE4FF',
    color: '#7B39FF',
    padding: theme.spacing(0, 1),
    textTransform: 'uppercase',
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 4,
  },
  iconInfo: {
    color: colors.grey600,
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',
  },
  rootLabel: {
    marginRight: theme.spacing(1),
  },
}));

const ALLOWED_CTA = [
  {
    label: 'Agregar al carrito',
    type: 'TO_SHOPPING_CART',
  },
  {
    label: 'Comprar ahora',
    type: 'TO_BUY_NOW',
  },
  {
    label: 'Pedir por whatsapp',
    type: 'TO_CHAT',
  },
  // {
  //   label: 'Pedir y pagar después',
  //   type: 'TO_ORDER_REQUEST',
  // },
];

export default function CallToActionSection(props: Props) {
  const {disabled, productPageSetting, saveProductPageSetting} = props;
  const classes = useStyles();

  const hasCTAFeature = useIsFeatureInTier('PRODUCT_CTA');
  const [modalType, setModalType] = useState<string | null>(null);
  const [primaryType, setPrimaryType] = useState<CTAType>('TO_SHOPPING_CART');
  const [secondaryType, setSecondaryType] = useState<string>('');

  const [enabled, setEnabled] = useState<boolean>(true);
  const storeMetadata = useStoreMetadata();

  const secondaryButtonDisabled = storeMetadata
    ? !storeMetadata?.featureRestrictions?.productPage.SECONDARY_BUTTON
    : false;

  // const handleEnableChange = e => {
  //   saveProductPageSetting({
  //     productPageSettingRequest: {
  //       storeProductCtaSetting: {
  //         enabled: e.target.checked,
  //       },
  //     },
  //   });
  // };

  const handleSaveSetting = (type: string, ctaType: CTAType) => {
    let rq: {[key: string]: any} = {
      enabled: true,
    };
    if (type === 'PRIMARY') {
      rq.primaryProductCtaButtonType = ctaType;
    } else {
      rq.secondaryProductCtaButtonType = ctaType;
    }

    saveProductPageSetting({
      productPageSettingRequest: {
        storeProductCtaSetting: rq,
      },
    });
  };

  // const buildSwitchControl = () => {
  //   return (
  //     <>
  //       {!hasCTAFeature && (
  //         <Chip label="PRO+" size="small" className={classes.newLabel} />
  //       )}
  //       <FormControlLabel
  //         control={
  //           <IosSwitch
  //             name="enabledCTA"
  //             checked={enabled}
  //             disabled={!!disabled || !hasCTAFeature}
  //             onChange={handleEnableChange}
  //           />
  //         }
  //         labelPlacement="start"
  //         label={
  //           <div className={classes.checkboxLabel}>
  //             {enabled ? 'Activado' : 'Desactivado'}
  //           </div>
  //         }
  //       />
  //     </>
  //   );
  // };

  const buildPreviewModal = () => {
    switch (modalType) {
      case CTATypeObject.TO_SHOPPING_CART:
        return <AddToCartModal open handleClose={handleCloseModal} />;
      case CTATypeObject.TO_BUY_NOW:
        return <BuyNowModal open handleClose={handleCloseModal} />;
      case CTATypeObject.TO_CHAT:
        return <WsspSaleModal open handleClose={handleCloseModal} />;
      case CTATypeObject.TO_ORDER_REQUEST:
        return <OrderRequestModal open handleClose={handleCloseModal} />;
      default:
        return null;
    }
  };

  const handleOpenModal = (type: string) => {
    setModalType(type);
  };

  const handleCloseModal = useCallback(() => {
    setModalType(null);
  }, []);

  const handleRadioChange = (e, type: string) => {
    if (!hasCTAFeature) return;
    // if (type === 'PRIMARY') setPrimaryType(e.target.value);
    // else setSecondaryType(e.target.value);

    // let storeProductCtaSetting: {[key: string]: any} = {
    //   enabled: true,
    // };

    handleSaveSetting(type, e.target.value);
    // if (e.target.value === '') {
    //   storeProductCtaSetting.secondaryProductCtaButtonType = '';
    // } else {
    // const ctaType = e.target.value;
    // if (type === 'PRIMARY') {
    //   storeProductCtaSetting.primaryProductCtaButtonType = ctaType;
    //   storeProductCtaSetting.secondaryProductCtaButtonType =
    //     ctaType === 'TO_SHOPPING_CART' ? 'TO_CHAT' : 'TO_SHOPPING_CART';
    // } else {
    //   storeProductCtaSetting.primaryProductCtaButtonType =
    //     ctaType === 'TO_SHOPPING_CART' ? 'TO_CHAT' : 'TO_SHOPPING_CART';
    //   storeProductCtaSetting.secondaryProductCtaButtonType = ctaType;
    // }
    // }

    // saveProductPageSetting({
    //   productPageSettingRequest: {
    //     storeProductCtaSetting,
    //   },
    // });
  };

  useEffect(() => {
    if (productPageSetting && productPageSetting.storeProductCtaSetting) {
      const {
        enabled,
        primaryProductCtaButtonType,
        secondaryProductCtaButtonType,
      } = productPageSetting.storeProductCtaSetting;
      if (primaryProductCtaButtonType)
        setPrimaryType(primaryProductCtaButtonType);
      setSecondaryType(secondaryProductCtaButtonType || '');
      setEnabled(enabled);
    }
  }, [productPageSetting]);

  return (
    <div>
      <Section title="Configuración de Botones accionables">
        <Typography className={classes.checkboxLabel}>
          Personaliza los botones que aparecerán en tu página de producto
        </Typography>

        {enabled && (
          <>
            <Divider className={classes.divider} />

            <div>
              <div className={classes.row}>
                <Typography className={classes.subtitle}>
                  Botón Primario
                </Typography>
              </div>

              <div>
                <RadioGroup
                  value={primaryType}
                  onChange={e => handleRadioChange(e, 'PRIMARY')}
                >
                  <Grid container>
                    {ALLOWED_CTA.map(cta => {
                      const isPrimaryCart = cta.type === 'TO_SHOPPING_CART';
                      const disabled = secondaryType === cta.type;
                      return (
                        <Grid
                          item
                          xs={12}
                          key={`primary-${cta.type}`}
                          className={classes.gridItem}
                        >
                          <FormControlLabel
                            classes={{root: classes.rootLabel}}
                            disabled={
                              !hasCTAFeature ||
                              disabled ||
                              secondaryButtonDisabled
                            }
                            value={cta.type}
                            control={<Radio color="primary" />}
                            labelPlacement="end"
                            label={
                              <div
                                className={`${classes.label} ${
                                  disabled ? classes.disabled : ''
                                }`}
                              >
                                {cta.label}{' '}
                              </div>
                            }
                          />
                          <InfoOutlined
                            onClick={() => handleOpenModal(cta.type)}
                            className={classes.iconInfo}
                          />
                          {isPrimaryCart && (
                            <div className={classes.recommended}>
                              Recomendado
                            </div>
                          )}
                        </Grid>
                      );
                    })}
                  </Grid>
                </RadioGroup>
              </div>

              <div className={classes.row}>
                <Typography className={classes.subtitle}>
                  Botón Secundario <span>(Opcional)</span>
                </Typography>
                {/* <CustomButton
                  startIcon={<Visibility />}
                  onClick={handleSecondaryPreview}
                >
                  Previsualizar
                </CustomButton> */}
              </div>

              <div>
                <RadioGroup
                  value={secondaryType}
                  onChange={e => handleRadioChange(e, 'SECONDARY')}
                >
                  <Grid container>
                    {ALLOWED_CTA.map(cta => {
                      const disabled = primaryType === cta.type;
                      return (
                        <Grid item xs={12} key={`secondary-${cta.type}`}>
                          <FormControlLabel
                            disabled={
                              !hasCTAFeature ||
                              disabled ||
                              secondaryButtonDisabled
                            }
                            value={cta.type}
                            control={<Radio color="primary" />}
                            labelPlacement="end"
                            label={
                              <div
                                className={`${classes.label} ${
                                  disabled ? classes.disabled : ''
                                }`}
                              >
                                {cta.label}
                              </div>
                            }
                          />
                        </Grid>
                      );
                    })}
                    <Grid item xs={12}>
                      <FormControlLabel
                        disabled={!hasCTAFeature || secondaryButtonDisabled}
                        value={''}
                        control={<Radio color="primary" />}
                        labelPlacement="end"
                        label={
                          <div
                            className={`${classes.label} ${
                              disabled ? classes.disabled : ''
                            }`}
                          >
                            Ninguno
                          </div>
                        }
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              </div>
            </div>
          </>
        )}
      </Section>
      {buildPreviewModal()}
      {/* <AddToCartModal /> */}
      {/* <WsspSaleModal /> */}
    </div>
  );
}

CallToActionSection.propTypes = {
  disabled: PropTypes.bool,
  productPageSetting: PropTypes.object,
  saveProductPageSetting: PropTypes.func.isRequired,
};
